document.addEventListener("DOMContentLoaded", function () {
    const authorsReset = document.querySelector(".all-authors__filter--button-reset");
    const authorsCount = document.querySelector(".authors-header__count span");
    const authorsList = document.getElementById("authors-list");
    const authors = Array.from(authorsList.getElementsByClassName("all-authors__item"));
    const alphabetLinks = document.querySelectorAll(".alphabet-link");
    const searchInput = document.querySelector(".author-search");
    const emptyMessage = document.querySelector(".empty-message");
    const searchValueSpan = document.getElementById("search-value");
    const paginationContainer = document.createElement("div");
    paginationContainer.classList.add("authors-pagination");
    let activeLink = null;

    const itemsPerPage = 30;
    let currentPage = 1;
    let totalPages = Math.ceil(authors.length / itemsPerPage);

    function renderPagination() {
        paginationContainer.innerHTML = "";

        if (totalPages <= 1) return;

        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, currentPage + 2);

        if (startPage > 1) {
            paginationContainer.appendChild(createPageLink(1));
            if (startPage > 2) paginationContainer.appendChild(createEllipsis());
        }

        for (let i = startPage; i <= endPage; i++) {
            paginationContainer.appendChild(createPageLink(i));
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) paginationContainer.appendChild(createEllipsis());
            paginationContainer.appendChild(createPageLink(totalPages));
        }

        authorsList.insertAdjacentElement("afterend", paginationContainer);
    }

    function createPageLink(page) {
        const pageLink = document.createElement("button");
        pageLink.classList.add("page-link");
        pageLink.textContent = page;
        if (page === currentPage) pageLink.classList.add("active");
        pageLink.addEventListener("click", () => {
            currentPage = page;
            updateURLWithPage(page);
            displayPage(currentPage);
        });
        return pageLink;
    }

    function createEllipsis() {
        const ellipsis = document.createElement("span");
        ellipsis.classList.add("ellipsis");
        ellipsis.textContent = "...";
        return ellipsis;
    }

    function displayPage(page) {
        const start = (page - 1) * itemsPerPage;
        const end = page * itemsPerPage;
        authors.forEach((author, index) => {
            if (index >= start && index < end) {
                author.style.display = "block";
            } else {
                author.style.display = "none";
            }
        });
        renderPagination();
    }

    function updateURLWithPage(page) {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);
        window.history.pushState({}, "", url);
    }

    function initializePagination() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageFromURL = parseInt(urlParams.get("page"), 10);
        currentPage = pageFromURL && pageFromURL > 0 && pageFromURL <= totalPages ? pageFromURL : 1;
        displayPage(currentPage);
    }

    function clearPagination() {
        paginationContainer.innerHTML = "";
    }

    function filterAuthors(query, letter = false) {
        let matchFound = false;
        let author_count = 0;
        const query_array = query.split(' ');
        authors.forEach(function (author) {
            let showAuthor = false;
            if (letter) {
                const arrayNames = author.getAttribute("data-author").toLowerCase().split(' ');

                // using last name for filtering
                const lastName = arrayNames[arrayNames.length - 1];
                if (lastName.startsWith(query.toLowerCase())) {
                    showAuthor = true;
                }

                // using first name for filtering - commented out as per requirement
                // arrayNames.forEach((name, index) => {
                //     if (index === 0 && name.startsWith(query.toLowerCase())) {
                //         showAuthor = true;
                //     }
                // });
            } else {
                const authorName = author.getAttribute("data-author").toLowerCase();
                if (authorName.includes(query.toLowerCase())) {
                    showAuthor = true;
                }
            }
            if (showAuthor) {
                author.style.display = "block";
                matchFound = true;
                author_count += 1;
            } else {
                author.style.display = "none";
            }
        });

        clearPagination();
        authorsCount.innerHTML = author_count;

        if (!matchFound) {
            emptyMessage.classList.remove("hidden");
            searchValueSpan.textContent = '"' + query + '"';
        } else {
            emptyMessage.classList.add("hidden");
            searchValueSpan.textContent = '';
        }
    }

    function clearFilter(all = false) {
        authors.forEach(function (author) {
            author.style.display = "block";
        });
        if (all) {
            alphabetLinks.forEach(function (link) {
                link.classList.remove("active");
            });
        }
        authorsCount.innerHTML = authors.length;
        emptyMessage.classList.add("hidden");
        searchValueSpan.textContent = '';
        currentPage = 1;
        displayPage(currentPage);
    }

    authorsReset.addEventListener("click", function () {
        clearFilter(true);
        searchInput.value = "";
        activeLink = null;
    });

    alphabetLinks.forEach(function (link) {
        link.addEventListener("click", function () {
            const letter = link.textContent.toLowerCase();
            if (link === activeLink) {
                link.classList.remove("active");
                clearFilter();
                activeLink = null;
            } else {
                if (activeLink) {
                    activeLink.classList.remove("active");
                }
                link.classList.add("active");
                filterAuthors(letter, true);
                activeLink = link;
            }
        });
    });

    searchInput.addEventListener("input", function () {
        const query = searchInput.value.toLowerCase();
        if (query === "") {
            clearFilter();
        } else {
            filterAuthors(query);
            if (activeLink) {
                activeLink.classList.remove("active");
                activeLink = null;
            }
        }
    });

    initializePagination();
});